import { useEffect } from 'react';

export const SITE_URL: string = (
  import.meta.env.VITE_SITE_URL || 'https://allchinabuyspread.quest'
).replace(/\/+$/, '');

export const SITE_NAME = 'AllChinaBuy Spreadsheet';

export const FAVICON_URL =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/14bc629c50c04cb08f38590896596985.jpeg';

export interface SeoInput {
  title: string;
  description: string;
  ogDescription?: string;
  keywords?: string;
  path: string;
  robots?: string;
  type?: string;
  image?: string;
}

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function removeMeta(attr: 'name' | 'property', key: string) {
  document.head.querySelector(`meta[${attr}="${key}"]`)?.remove();
}

function upsertLink(rel: string, href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function applySeo(input: SeoInput) {
  const url = input.path === '/' ? `${SITE_URL}/` : `${SITE_URL}${input.path}`;
  const socialDescription = input.ogDescription || input.description;

  document.title = input.title;

  upsertMeta('name', 'description', input.description);

  if (input.keywords) {
    upsertMeta('name', 'keywords', input.keywords);
  } else {
    removeMeta('name', 'keywords');
  }

  upsertLink('canonical', url);

  upsertMeta('name', 'robots', input.robots || 'index, follow');

  upsertMeta('property', 'og:type', input.type || 'website');
  upsertMeta('property', 'og:title', input.title);
  upsertMeta('property', 'og:description', socialDescription);
  upsertMeta('property', 'og:url', url);
  upsertMeta('property', 'og:site_name', SITE_NAME);
  if (input.image) {
    upsertMeta('property', 'og:image', input.image);
  } else {
    removeMeta('property', 'og:image');
  }

  upsertMeta('name', 'twitter:card', 'summary_large_image');
  upsertMeta('name', 'twitter:title', input.title);
  upsertMeta('name', 'twitter:description', socialDescription);
  if (input.image) {
    upsertMeta('name', 'twitter:image', input.image);
  } else {
    removeMeta('name', 'twitter:image');
  }
}

export function useSeo(input: SeoInput) {
  useEffect(() => {
    applySeo(input);
  }, [
    input.title,
    input.description,
    input.ogDescription,
    input.keywords,
    input.path,
    input.robots,
    input.type,
    input.image,
  ]);
}